import images from 'images'

interface Meta {
  title: string
  logo: any
  url?: string
  introURL: string
}

export const EXCHANGE_META: { [key: string]: Meta } = {
  DMMB: {
    title: 'DMM Bitcoin',
    logo: images.exchanges.DMMB,
    url: 'https://p-salm.jp/ad/p/r?_site=70&_article=24&_link=42&_image=42',
    introURL: 'https://www.coinjinja.com/blog/posts/2019/8/exchange_dmmbitcoin',
  },
  GMOC: {
    title: 'GMOコイン',
    logo: images.exchanges.GMOC,
    url: 'https://www.tcs-asp.net/alink?AC=C100190&LC=GMOZ1&SQ=0&isq=100',
    introURL: 'https://www.coinjinja.com/blog/posts/2019/8/exchange_gmocoin',
  },
  CCJP: {
    title: 'Coincheck',
    logo: images.exchanges.CCJP,
    url: 'https://www.tcs-asp.net/alink?AC=C100190&LC=COINC1&SQ=0&isq=210 ',
    introURL: 'https://www.coinjinja.com/blog/posts/2019/8/exchange_coincheck',
  },
  BTBK: {
    title: 'bitbank',
    logo: images.exchanges.BTBK,
    url: 'http://p-salm.jp/ad/p/r?_site=70&_article=3',
    introURL: 'https://www.coinjinja.com/blog/posts/2019/8/exchange_bitbank',
  },
  QUON: {
    title: 'Liquid',
    logo: images.exchanges.QUON,
    url: 'http://p-salm.jp/ad/p/r?_site=70&_article=5',
    introURL: 'https://www.coinjinja.com/blog/posts/2019/8/exchange_liquid',
  },
  DCRT: {
    title: 'DeCurret',
    logo: images.exchanges.DCRT,
    introURL: 'https://www.coinjinja.com/blog/posts/2019/8/exchange_decurret',
  },
  BTFL: {
    title: 'bitFlyer',
    logo: images.exchanges.BTFL,
    url: 'https://bitflyer.com/ja-jp/account-create',
    introURL: 'https://www.coinjinja.com/blog/posts/2019/9/exchange_bitflyer',
  },
}
